import React, { useEffect, useState } from 'react';
import M_EMT_BASIC from './M_EMT_BASIC';
import { useSearch1 } from './M_EMT_BASIC_Query';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { useDispatch } from 'react-redux';

function M_EMT_BASICF() {
  const dispatch = useDispatch();
  const [emTelList, setEmTelList] = useState([]);

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('appBarDefault'));
  }, [dispatch]);

  useSearch1({
    onSuccess: (rows) => {
      setEmTelList(rows);
    },
  });

  return (
    <div className="wrap h-full min-h-0 flex-col bg-[#f8faf9]">
      <M_EMT_BASIC emTelList={emTelList} />
    </div>
  );
}

export default M_EMT_BASICF;
